module.exports = __webpack_public_path__ + "media/images/360/REM_sleep_night_stars-630faba677700679ea93a9c58ae1a49d.webp";